import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { timer } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class VisitorProvider {

  ismURL = environment.ismUrl;
  URL = environment.vmsUrl;
  api_token: string;
  user_id: number;
  public companyNameMap : Map<string, any> = new Map<string, any>();

  constructor(public http: HttpClient, private storage: Storage) {
    try{
      this.storage.get("loginDetails").then((val) => {
        if(val!=null){
          this.api_token = val.api_token;
          this.user_id = val.id;
        }
      });
    }catch(e){
      console.error(e);
    }
  }

  makecompanyNameMap(){
    this.getToken().then((val) => {
      if(val){
        let url = this.getUrl(`/v1/mastercompanies`, val);
        this.http.get<Response>(url).toPromise().then(val => {
          this.companyNameMap.clear();
          if(val.status == "success"){
            val.data.forEach(val => {
              this.companyNameMap.set(val.name, val);
            });
          }
        });
      }
    });
  }

  getCompanyIcon(name){
    let data = this.companyNameMap.get(name);
    if(data && data.icon){
      return data.icon;
    }else{
      return "";
    }
  }

  getVisits(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/getVisitsForResident`,val), {
          residentId: val.id,
          input: ""
        })
        .toPromise();
      }
    });
  }

  getVisitById(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/getVisitById`,val) + `&id=${id}`)
        .toPromise();
      }
    });
  }

  deleteVisit(id: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.delete<Response>(this.getUrl(`/v1/society/${val.societyId}/residentdeletevisit`,val)+"&id="+id+"&resident_id="+val.id)
        .toPromise();
      }
    });
  }

  allow(visit: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/allowVisit`,val), {
          allow: 1, 
          visitId: visit.id
        })
        .toPromise();
      }
    });
  }

  deny(visit: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/allowVisit`,val), {
          allow: 0, 
          visitId: visit.id
        })
        .toPromise();
      }
    });
  }

  ane(visit: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/visitAttended`,val), {
          user_id: val.id,
          visit_id: visit.id
        })
        .toPromise();
      }
    });
  }

  nv(visit: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/visitAttended`,val), {
          user_id: val.id,
          visit_id: visit.id,
          attended: 0
        })
        .toPromise();
      }
    });
  }

  extendTime(visit: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/extendvisittime`,val), {
          extendby: visit.time,
          resident_id: val.id,
          visit_id: visit.id
        })
        .toPromise();
      }
    });
  }

  getPass(input: string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/searchPass`,val), {
          residentId: val.id,
          input: input
        })
        .toPromise();
      }
    });   
  }

  deletePass(pass: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v2/society/${val.societyId}/cancelpass`,val), 
        {
          id: pass.id
        }).toPromise();
      }
    });  
  }

  createPass(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v2/society/${val.societyId}/createpass`,val),data)
        .toPromise();
      }
    });  
  }

  editPass(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v2/society/${val.societyId}/editpass`,val),data)
        .toPromise();
      }
    });  
  }

  getCompaniesByCategory(category: string = null){
    return this.getToken().then((val) => {
      if(val){
        let url = this.getUrl(`/v1/mastercompanies`, val);
        if(category) url += `&category=${category}`;
        return this.http.get<Response>(url)
        .toPromise();
      }
    });
  }

  generatePass(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v2/society/${val.societyId}/createallpass`,val),data)
        .toPromise();
      }
    }); 
  }


  getNotificationStatus(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getIsmUrl(this.ismURL,`/getNotificationSound`,val))
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getIsmUrl(url:string, link: string, val: any):string {
    return `${url}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}


// WEBPACK FOOTER //
// ./src/providers/visitor/visitor.ts